<script lang="ts" setup>
import { ControlPanelLight, controlPanelLightDevTranslation } from '@ilteducation/light-control-panel';
import { onBeforeMount } from 'vue';
import { useLocalisation } from '@/plugins/translation';
import { createSecureLoginLocalRedirectUrl, useAuthentication } from '@ilteducation/ilt-auth';
import config from '@/config/ConfigProvider';

const { includeAdditionalProject, addAdditionalTranslation, language: currentLanguage } = useLocalisation();
const { createEscalationLink } = useAuthentication();

onBeforeMount(() => {
  if (currentLanguage.value !== 'dev') {
    addAdditionalTranslation(controlPanelLightDevTranslation);
    includeAdditionalProject('LightControlPanel', false, true);
  } else {
    addAdditionalTranslation(controlPanelLightDevTranslation);
  }
});

const onEscalatedLoginRequested = () => {
  const path = window.location.pathname + window.location.search;
  const localRedirectUrl = createSecureLoginLocalRedirectUrl(window.location.origin, config.value('basePath'), path);

  const url = createEscalationLink({
    appName: config.value('serviceName'),
    clientId: config.value('authClientId'),
    localRedirectUrl,
  });

  window.location.href = url;
};
</script>

<template>
  <v-container fluid class="h-100 pa-0">
    <ControlPanelLight itemKey="panel" :onEscalatedLoginRequested="onEscalatedLoginRequested">
      <!-- <template #settings.user="sidebarContext">
        <UserSideBarSettings v-bind="sidebarContext" />
      </template> -->
    </ControlPanelLight>
  </v-container>
</template>
